"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Register_1 = require("./Register");
exports.Register = Register_1.Register;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy90ZXN0L1NhbXBsZS9wYXJ0cy9IZWFsdGhIaXN0b3J5L3BhcnRzL1JlZ2lzdGVyL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsdUNBQW1DO0FBQTNCLDhCQUFBLFFBQVEsQ0FBQSJ9